import './bootstrap';
import './main.scss';
import { createFreyaApp } from '@precon-tools-suite-by-shared/shared-layout-freya-ui';
import theme from '@precon-tools-suite-by-shared/ui-theme/freya-precon-food-management';
import router from './plugins/router';
import menuItems from './main-menu';
import vueBackendClientPlugin from '@precon-tools-suite-by-shared/shared-backend-client-vue';
import receivers from '@precon-tools-suite-by-shared/primevue-receivers';
import preconAuthenticationPlugin from '@precon-tools-suite-by-shared/shared-auth-feature';
import primevueComponents from './plugins/primevue';
import fieldsPlugin from '@precon-tools-suite-by-shared/shared-common-forms-ui';
import fileDownloadPlugin from '@precon-tools-suite-by-shared/shared-file-downloads-feature';
import importsPlugin from '@precon-tools-suite-by-shared/gino-user-imports-feature';
import ginoProcurementFeaturePlugin from '@precon-tools-suite-by-shared/gino-procurements-feature';
import ginoAuditsFeaturePlugin from '@precon-tools-suite-by-shared/gino-audits-feature';
import ginoRiskDatabaseFeature from '@precon-tools-suite-by-shared/gino-risk-database-feature';
import preconDataNodesPlugin from '@precon-tools-suite-by-shared/shared-data-nodes-feature';
import ginoRiskConfigurationsPlugin from '@precon-tools-suite-by-shared/gino-risk-configurations-feature';
import ginoVerificationConfigurationsPlugin from '@precon-tools-suite-by-shared/gino-verification-configurations-feature';
import ginoReportsPlugin from '@precon-tools-suite-by-shared/gino-analysis-reports-feature';
import colorsPlugin from '@precon-tools-suite-by-shared/shared-colors-ui';
import jobsPlugin from '@precon-tools-suite-by-shared/shared-jobs-feature';
import predicatesPlugin from '@precon-tools-suite-by-shared/gino-predicates-feature';
import toastsPlugin from '@precon-tools-suite-by-shared/shared-common-toasts-ui';

import tagsFeaturePlugin from '@precon-tools-suite-by-shared/shared-tags-feature';

const app = createFreyaApp({
    theme,
    menuItems,
    hideSidebarTimeout: 100,
    rightBarPartials: [
        '@precon-tools-suite-by-shared/shared-jobs-feature/partials/MyJobs',
        '@precon-tools-suite-by-shared/shared-auth-feature/partials/MyTeamOverview',
        '@precon-tools-suite-by-shared/gino-analysis-reports-feature/partials/ReportState',
    ],
});

app.use(vueBackendClientPlugin, {
    scopes: {
        PreconBackend: ['Gino.CurrentTeam.Products.Read'],
    },
    router,
    appName: __APP_NAME__,
    appVersion: __APP_VERSION__,
    connectToDevTools: import.meta.env.DEV,
    logGraphQLErrors: import.meta.env.DEV,
    logGraphQLRoundTrip: import.meta.env.DEV,
    logMsalEvents: import.meta.env.DEV,
    loginWithTeam: true,
    // passwordResetPolicy: 'b2c_1a_passwordreset',
    // profileEditPolicy: 'b2c_1a_profileedit',
});

app.use(primevueComponents);
app.use(colorsPlugin);

// Use partials.
app.use(receivers, {
    modules: import.meta.glob('./partials/**/*.vue'),
    pathPrefix: './partials/',
});
app.use(fieldsPlugin);

app.use(preconAuthenticationPlugin, {
    fetchRolesFromBackendIfMissingInToken: true,
    router,
});
app.use(fileDownloadPlugin);
app.use(importsPlugin);

// Use the primevue components.
app.use(ginoProcurementFeaturePlugin);
app.use(ginoRiskDatabaseFeature);
app.use(preconDataNodesPlugin);
app.use(ginoRiskConfigurationsPlugin);
app.use(ginoVerificationConfigurationsPlugin);
app.use(ginoReportsPlugin);
app.use(jobsPlugin);
app.use(predicatesPlugin);
app.use(toastsPlugin);
app.use(ginoAuditsFeaturePlugin);
app.use(tagsFeaturePlugin);

// Mount the router (will also resolve the current route!)
app.use(router);

// Start the application.
app.mount('#app');
